import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';

@Component({
    selector: 'ds-pagination',
    templateUrl: './pagination.component.html'
}) export class DsPaginationComponent {
    @Input() current: string = "1";
    @Input() id: string = 'pagination-standard';
    @Input() max: string = "1";
    @Input() limit: string = "5";
    @Output() pageChange = new EventEmitter<number>();

    pages: any;

    constructor() {
    }

    ngOnInit() {
        this.fillPages();
    }

    fillPages() {
        var offset = Math.floor(parseInt(this.limit) / 2);
        this.pages = [];
        var current = parseInt(this.current, 10);
        var max = parseInt(this.max, 10);
        var page = current - offset > 0 ? current - offset : 1;
        var stop = current + offset > max ? max : current + offset;
        for (; page <= stop; page++) {
            this.pages.push(page);
        }
    }

    changePage(page) {
        if (page > 0 && page <= parseInt(this.max, 10) && page != parseInt(this.current, 10)) {
            this.pageChange.emit(page);
        }
    }

    canGoBack() {
        return parseInt(this.current, 10) > 1;
    }
    canGoForward() {
        return parseInt(this.current, 10) < parseInt(this.max, 10);
    }

    firstPage() {
        this.changePage(1);
    }

    previousPage() {
        this.changePage(parseInt(this.current, 10) - 1);
    }

    nextPage() {
        this.changePage(parseInt(this.current, 10) + 1);
    }

    lastPage() {
        this.changePage(parseInt(this.max, 10));
    }
 }



// WEBPACK FOOTER //
// ./src/app/pagination/pagination.component.ts